module.exports = "https://web-assets.ifttt.com/packs/media/docs/reporting_analytics-e90401b9.png";